const dealerAddress = (dealer) => {
  if (dealer.attributes['primary-address1'] && dealer.attributes["city-state"]) {
    return `${dealer.attributes['primary-address1']} ${dealer.attributes['primary-address2'] && dealer.attributes['primary-address2']}`
  }
  return 'None'
}

export default dealerAddress